module.exports = __webpack_public_path__ + "static/media/hotel_image_holder.afaf0a47.svg";